package org.hs_soft.runmynesto.domain.model.menu

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class MenuItemsEnum(
    val id:String,
    val iconPath: String,
    val iconPath20: String,
    val subData:List<SubMenuModel>,
) {
    DASHBOARD(
        id="dashboard",
        iconPath = Res.PathIcon.dashboard,
        iconPath20 = Res.PathIcon.dashboard20,
        subData = listOf(),
    ),
    PRODUCT(
        id="prodcut",
        iconPath = Res.PathIcon.production,
        iconPath20 = Res.PathIcon.product20,
        subData = listOf(),
    ),
    TEMPLATE(
        id="template",
        iconPath = Res.PathIcon.template,
        iconPath20 = Res.PathIcon.product20,
        subData = listOf(),
    ),
    USER(
        id="user",
        iconPath = Res.PathIcon.user,
        iconPath20 = Res.PathIcon.user20,
        subData = listOf(),
    ),
    MEDIA_CENTER(
        id="mediaCenter",
        iconPath = Res.PathIcon.mediaCenter,
        iconPath20 = Res.PathIcon.mediaCenter20,
        subData = listOf(),
    ),
    CUSTOMER_CARD(
        id="customerCard",
        iconPath = Res.PathIcon.customerCard,
        iconPath20 = Res.PathIcon.customerCard20,
        subData = listOf(),
    ),
    CLOSING_REPORTS(
        id="closingReports",
        iconPath = Res.PathIcon.closingReport,
        iconPath20 = Res.PathIcon.closing20,
        subData = listOf(),
    ),
    STATISTIC(
        id="statistic",
        iconPath = Res.PathIcon.statistic,
        iconPath20 = Res.PathIcon.statistic20,
        subData = listOf(),
    ),
    OPTIONS(
        id="option",
        iconPath = Res.PathIcon.options,
        iconPath20 = Res.PathIcon.option20,
        subData = listOf(),
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            DASHBOARD -> strings.dashboard
            PRODUCT -> strings.product
            TEMPLATE -> strings.template
            USER -> strings.user
            MEDIA_CENTER -> strings.mediaCenter
            CUSTOMER_CARD -> strings.customerCard
            CLOSING_REPORTS -> strings.closingReports
            STATISTIC -> strings.statistic
            OPTIONS -> strings.options
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                DASHBOARD -> strings.dashboard
                PRODUCT -> strings.product
                TEMPLATE -> strings.template
                USER -> strings.user
                MEDIA_CENTER -> strings.mediaCenter
                CUSTOMER_CARD -> strings.customerCard
                CLOSING_REPORTS -> strings.closingReports
                STATISTIC -> strings.statistic
                OPTIONS -> strings.options
            }
        }
}